import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=ACH Direct Debit",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Vector",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M22.2818 18.6599C19.2752 18.2543 16.6183 16.7459 15.324 14.7098C14.4609 13.352 14.3248 11.4017 14.9935 9.973C15.7069 8.44824 16.9122 7.30015 18.7252 6.41827C20.1027 5.74805 21.5363 5.39542 23.1735 5.32377L24.4966 5.26562L24.4675 7.66064L24.4384 10.0557L23.5219 10.1059C21.5671 10.2112 19.4629 10.7128 18.122 11.3923C16.9105 12.0061 16.0937 13.0979 16.2414 13.9061C16.5588 15.643 19.1353 17.2699 22.3451 17.7602C24.4305 18.0787 26.1615 17.7398 27.5739 16.7371C28.4135 16.1407 28.8021 15.6888 29.2558 14.7808C30.0876 13.1163 30.0812 10.4628 29.2417 8.66761C28.5818 7.25757 27.0061 6.0339 25.4223 5.7017C24.813 5.57441 24.5728 5.29564 25.0718 5.29564C26.2489 5.29564 28.7499 6.0625 30.0301 6.816C31.6479 7.76828 33.0142 9.49921 33.324 10.9889C34.0128 14.3023 31.2446 17.4466 26.752 18.4535C25.5772 18.7169 23.4349 18.8156 22.2818 18.6599ZM23.5138 17.2251C21.3614 16.4654 20.287 15.357 20.287 13.897C20.287 12.8275 20.7677 12.0787 21.9428 11.318C22.5132 10.9487 24.1041 10.2554 24.381 10.2554C24.4554 10.2554 24.4923 11.4561 24.4923 13.8676C24.4923 16.6868 24.4628 17.4794 24.3575 17.4777C24.2833 17.4764 23.9038 17.363 23.5138 17.2251Z",
				fill: "white"
			})
		})
	}) })
});
export default SvgAch;
